import React, { useState, useMemo, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import {
  Formik,
  Field,
  ErrorMessage,
  FieldArray,
  useFormik,
  FormikProvider,
} from "formik";
import NavigationServicesHeader from "../Header/NavigationServicesHeader";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import HousingService from "../Services/HousingService";
import { store } from "../App";
import ShowAlert from "./alert";
import { BiUser } from "react-icons/bi";
const ChangeUser = () => {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Required"),
  });

  function handleGoBack() {
    history.goBack();
  }

  const formik = useFormik({
    initialValues: {
      username: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const params = {
          username: values.username,
          prevUserId: localStorage.getItem("prevUserId"),
        };
  
        store.dispatch({ type: "SHOW_SPINNER" });
  
        const res = await HousingService.changeUsername(params);
  
        if (res.data[0].responseMsg === "User Changed") {
          store.dispatch({ type: "HIDE_SPINNER" });
  
          localStorage.setItem("user", JSON.stringify(res.data));
          localStorage.setItem("token", res.data[0].token);
          localStorage.setItem("userId", values.username);
          localStorage.setItem("username", values.username);
  
          history.push("/Dashboardheader");
        } else {
          ShowAlert("Invalid User Name", "error");
          store.dispatch({ type: "HIDE_SPINNER" });
        }
      } catch (error) {
        console.error("Error:", error);
        ShowAlert("An error occurred", "error");
        store.dispatch({ type: "HIDE_SPINNER" });
      } finally {
        setSubmitting(false);
      }
    },
  });
  

  const handleTextChange = (event) => {
    event.preventDefault();
    setUsername(event.target.value.toUpperCase());
  };

  const changeCase = (event) => {
    event.preventDefault();
    setUsername(event.target.value.toUpperCase());
  };

  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container>
        <OFMSUI.Row>
          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="page-titlespacing"
          >
            <div className="inner-herbpage-service-title1">
              <h1 style={{ marginLeft: "-15px" }}>CHANGE USER</h1>
            </div>
          </OFMSUI.Col>
          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="page-titlespacing"
          >
            <button
              className="btn btn-primary"
              style={{
                textAlign: "right",
                float: "right",
                marginTop: "17px",
                backgroundColor: "#603913",borderColor: "#603913", color: "#fff"
              }}
              type="reset"
              onClick={() => history.goBack()}
            >
              Back
            </button>
            <div className="d-grid  "></div>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <FormikProvider value={formik}>
        <OFMSUI.Container className="outer-page-content-container ">
          <OFMSUI.Row className="p-4 justify-content-center">
            <OFMSUI.Col
              xs={12}
              sm={12}
              md={12}
              lg={4}
              xl={4}
              xxl={4}
              className="mx-auto"
            >
              <form onSubmit={formik.handleSubmit}>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    {" "}
                    <BiUser className="font_size text-white" />{" "}
                  </span>
                  <Field
                    type="text"
                    name="username"
                    maxLength={20}
                    placeholder="username"
                    className={
                      formik.touched.username && formik.errors.username
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      handleTextChange(e);
                      formik.handleChange(e);
                    }}
                    onMouseEnter={changeCase}
                    value={username}
                  />
                  {formik.touched.username && formik.errors.username && (
                    <div className="invalid-feedback">
                      {" "}
                      <span style={{ color: "red" }}>required</span>{" "}
                    </div>
                  )}
                </div>
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={4}
                  xl={4}
                  xxl={4}
                  className="mx-auto"
                >
                  <div
                    className="d-grid mt-3"
                    style={{ width: "50px", alignContent: "center" }}
                  >
                    <button type="submit" className="btn btn-success btn-sm">
                      Change
                    </button>
                  </div>
                </OFMSUI.Col>
              </form>
            </OFMSUI.Col>
          </OFMSUI.Row>
        </OFMSUI.Container>
      </FormikProvider>
    </>
  );
};
export default ChangeUser;
